const CommonConstants = {
  // API_LOGIN_PATH: '/auth/login',
  API_REGISTER_USER: "/api/v1/tokens/sign_up",
  API_LOGIN_PATH: "/auth/user/login",
  API_ADMIN_LOGIN_PATH: "/admin/api/v1/tokens/sign_in",
  API_GET_ADMIN_INFO_PATH: "/admin/api/v1/tokens/info",
  API_GET_ADMIN_LOGOUT_PATH: "/admin/api/v1/tokens/sign_out",
  API_DOWNLOAD_CATEGORIES_PATH: "/admin/api/v1/categories/import",
  API_ADMIN_CATEGORIES_PATH: "/admin/api/v1/categories",
  API_SYNC_DOUYIN_PRODUCTS_PATH: "/admin/api/v1/douyin_products/sync",
  API_SYNC_DOUYIN_PRODUCT_DETAILS_PATH: "/admin/api/v1/douyin_products/sync_missing_details",
  API_SYNC_HOT_PRODUCTS_PATH: "/admin/api/v1/hot_products/sync",
  API_SYNC_AWEME_GOODS_PATH: "/admin/api/v1/aweme_goods/sync",
  API_SYNC_HOT_PRODUCTS_CATEGORIES_PATH: "/admin/api/v1/hot_products/sync_by_categories",
  API_SYNC_HOT_PRODUCTS_DETAILS_PATH: "/admin/api/v1/hot_products/sync_missing_details",
  API_SYNC_AWEME_GOODS_CATEGORIES_PATH: "/admin/api/v1/aweme_goods/sync_by_categories",
  API_SYNC_AWEME_GOODS_DETAILS_PATH: "/admin/api/v1/aweme_goods/sync_missing_details",
  API_SYNC_FEATURED_STORES_PATH: "/admin/api/v1/featured_stores/sync",
  API_SYNC_STORE_LOCATIONS_PATH: "/admin/api/v1/store_locations/sync",
  API_APP_SETTINGS_PATH: "/admin/api/v1/app_settings",
  API_SYNC_COUNTS_PATH: "/admin/api/v1/sync_counts",

  API_ADMIN_BLOGS_PATH: "/admin/api/v1/blogs",
  API_ADMIN_USERS_PATH: "/admin/api/v1/users",
  API_ADMIN_DEPOSITS_PATH: "/admin/api/v1/deposits",
  API_ADMIN_TOP_VIDEO_PRODUCTS_PATH: "/admin/api/v1/top_video_products",
  API_ADMIN_SUBSCRIPTION_PACKAGES_PATH: "/admin/api/v1/subscription_packages",
  API_ADMIN_PAYMENT_HISTORIES_PATH: "/admin/api/v1/payment_histories",

  //user api
  API_GET_CATEGORIES_PATH: "/api/v1/categories",
  // API_DOUYIN_PRODUCTS_PATH: "/api/v1/douyin_products",
  API_DOUYIN_PRODUCTS_PATH: "/api/v1/douyin_products/index2",
  API_SYNC_DOUYIN_CATEGORIES_PATH: "/admin/api/v1/douyin_products/sync_by_categories",
  API_HOT_PRODUCTS_PATH: "/api/v1/hot_products",
  API_AWEME_GOODS_PATH: "/api/v1/aweme_goods/index2",
  API_FEATURED_STORES_PATH: "/api/v1/featured_stores",
  API_STORE_LOCATIONS_PATH: "/api/v1/store_locations",
  API_PRODUCT_DETAIL_PATH: "/api/v1/product-detail",
  API_BLOGS_PATH: "/api/v1/blogs",
  API_TOP_VIDEO_PRODUCTS_PATH: "/api/v1/top_video_products",
  API_ADMIN_TRENDING_VIDEOS_PATH: "/admin/api/v1/trending_videos",
  API_ADMIN_WEEKLY_VIDEO_PRODUCTS_PATH: "/admin/api/v1/weekly_video_products",
  API_SYNC_TRENDING_VIDEOS_PATH: "/admin/api/v1/trending_videos/sync_by_tags",
  API_TRENDING_VIDEOS_PATH: "/api/v1/trending_videos",
  API_TRENDING_COVERS_PATH: "/api/v1/trending_covers",
  API_TRENDING_AVATARS_PATH: "/api/v1/trending_avatars",
  API_WEEKLY_VIDEO_PRODUCTS_PATH: "/api/v1/weekly_video_products",
  API_RESET_PASSWORD_PATH: "/api/v1/mailler/reset_password",
  API_FORGOT_PASSWORD_PATH: "/api/v1/mailler/forgot_password",
};

export default CommonConstants;
